import { sharedStationTooltipMessage } from '@app/components/stations/station-messages';
import { isSharedStation } from '@app/core/stations/helpers';
import { Station } from '@mi-front/core';
import EmergencyIcon from '@mui/icons-material/Emergency';
import { Box, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';

interface StatusSharedStationBadgeProps {
  station: Station;
  compact: boolean;
}

/**
 * Inline shared-station badge shown next to the station name in the status header.
 */
export function StatusSharedStationBadge({ station, compact }: StatusSharedStationBadgeProps) {
  const { $t } = useIntl();

  if (!isSharedStation(station)) {
    return null;
  }

  return (
    <Tooltip title={$t(sharedStationTooltipMessage)} placement="top">
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          width: compact ? 16 : 20,
          height: compact ? 16 : 20,
          borderRadius: '50%',
          bgcolor: 'background.paper',
          boxShadow: 1,
        }}
      >
        <EmergencyIcon
          sx={{
            fontSize: compact ? '0.75rem' : '0.875rem',
            color: 'text.secondary',
          }}
        />
      </Box>
    </Tooltip>
  );
}
